<script>
import ListingModel from "@/views/Request/RecruitmentRequest/Components/ListingModel.vue";

export default {
    name: "RecruitmentRequests",
    components: {ListingModel},
};
</script>

<template>
    <ListingModel type="REQUEST"/>
</template>